import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
// Reuse the shared demo stylesheet, then the Beacon brand override + ledger UI.
import "@demo/styles.css";
import "./brand.css";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
